import React, { useCallback, useState } from 'react';
import { CharitySelector } from '../components/UI/charities/CharitySelector';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { translations } from '../utils/translations/translations-manager';

const CharitySelectionPage: React.FC = () => {
  const [isSingleCharity, setIsSingleCharity] = useState<boolean>()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const onSuccess = useCallback(() => {
    navigate('/')
  }, [dispatch, navigate])
  return (
    <div className='w-full h-screen overflow-hidden flex justify-center items-center'>
      <div className='flex flex-col w-2/5 justify-center items-center'>
        {isSingleCharity === false && <p className={`font-semibold pl-4 mb-5`}>{translations.texts.select_a_charity_from_list.toString()}</p>}
        <div className='flex w-96 justify-center'>
          <CharitySelector onSuccess={onSuccess} skipCharitySelection={(value) => setIsSingleCharity(value)} />
        </div>
      </div>
    </div>
  );
};

export default CharitySelectionPage;
